<section id="ngx-datatable-basic">
    <div class="row">
        <div class="col-sm-12">

            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Documentos Onboarding</h4>
                </div>
                <div class="card-body">
                    <ngx-datatable [rows]="rowsPage" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="70"
                        [scrollbarH]="scrollBarHorizontal" [rowHeight]="'auto'" [reorderable]="reorderable"
                        [externalPaging]="true" [count]="page.totalElements" [offset]="page.pageNumber - 1"
                        [limit]="page.size" (page)='setPage($event)' class="bootstrap core-bootstrap"
                        [selectionType]="selectionType.checkbox">
                        <i class="ft-edit-2 info font-medium-1 mr-2"></i>

                        <ngx-datatable-column name="Status" prop="name" [width]="400" [sortable]="false"
                            [canAutoResize]="false" [draggable]="false" [resizeable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" [checked]="row?.url !== null && row?.url !== undefined"
                                        disabled class="styled-checkbox" />
                                    <p *ngIf="row?.url === null || row?.url === undefined">Não Enviado</p>
                                    <p *ngIf="row?.url !== null && row?.url !== undefined">Enviado</p>
                                    <p *ngIf="row?.isFileSent == true">Não Possui</p>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Tipo" prop="type">
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Prazo de Envio" prop="deadline">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{row.deadline | date:'dd/MM/yyyy'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Ações">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <button type="button" class="btn btn-info mr-1 mb-1"
                                    *ngIf="row?.url === null || row?.url === undefined" (click)="upload(row)"><i
                                        class="fa ft-upload"></i></button>
                                <button type="button" class="btn btn-info mr-1 mb-1" (click)="detail(row)"
                                    *ngIf="row?.url !== null && row?.url !== undefined"><i
                                        class="fa ft-edit"></i></button>
                                <button type="button" class="btn btn-info mr-1 mb-1"
                                    *ngIf="row?.url !== null && row?.url !== undefined" (click)="view(row)"><i
                                        class="fa ft-eye"></i></button>
                                <button type="button" class="btn btn-info mr-1 mb-1" (click)="delete(row)"
                                    *ngIf="row?.url !== null && row?.url !== undefined"><i
                                        class="fa ft-trash"></i></button>
                                <button type="button" class="btn btn-info mr-1 mb-1" (click)="nonOpting(row)"
                                    *ngIf="row?.type === 'Planilha/Word de horas extras/Comissão/Bônus ou prêmio/Faltas/Atrasos' && (row?.url === null || row?.url === undefined)"><i
                                        class="fa ft-x-circle"></i></button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</section>